export class GMarkerLabel{

    color : string;
    fontWeight : string;
    fontSize : string;
    text?: string

    constructor(color? : string, fontWeight?: string, fontSize?: string, text? : string){

		this.color = color ? color : "#ffffff";
		this.fontWeight = fontWeight ? fontWeight : "bold";
		this.fontSize = fontSize ? fontSize : "14px" ;
        this.text = text;
    }

}